import ResourceCard from '@/components/base/ResourceCard';
import { resources } from '@/mocks/resources';

export default function HotResources() {
  const hotResources = resources.filter((r) => r.isHot).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              热门资源推荐
            </h2>
            <p className="text-foreground-500 text-sm">
              最受用户欢迎的免费资源，口碑之选
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {hotResources.map((resource) => (
            <ResourceCard key={resource.id} {...resource} />
          ))}
        </div>
      </div>
    </section>
  );
}